// extracted by mini-css-extract-plugin
export default {"pageLayout":"Suppliers_pageLayout__2jeN9"};